export default {"src":"/_next/static/media/google.e3401963.svg","height":44,"width":180,"blurWidth":0,"blurHeight":0};